<template>
    <section class="max-w-3xl mx-auto my-10 px-4">
      <h2 class="text-3xl font-bold mb-6 text-center">Sık Sorulan Sorular</h2>
  
      <div
        v-for="(item, index) in faqList"
        :key="index"
        class="mb-4 border rounded-2xl shadow-sm"
      >
        <button
          @click="toggle(index)"
          class="w-full flex justify-between items-center text-left px-5 py-4 text-lg font-medium bg-white hover:bg-gray-50 rounded-2xl transition"
        >
          <span>{{ item.name }}</span>
          <svg
            class="w-5 h-5 transform transition-transform"
            :class="{ 'rotate-180': activeIndex === index }"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M19 9l-7 7-7-7" />
          </svg>
        </button>
        <div
          v-if="activeIndex === index"
          class="px-5 pb-5 text-gray-700"
        >
          {{ item.acceptedAnswer.text }}
        </div>
      </div>
    </section>
  </template>
  
  <script setup>
  import { ref } from 'vue'
  
  const activeIndex = ref(null)
  
  const toggle = (index) => {
    activeIndex.value = activeIndex.value === index ? null : index
  }

  const pageData = usePageData();
  
  // Örnek veri (mainEntity'den gelen FAQ içeriği buraya bağlanır)
  const faqList = ref([]); 
  
  // Örnek veri yükleme (gerçek uygulamada API'den veya başka bir kaynaktan alınabilir)
  faqList.value = pageData.value?.faq;
  </script>